import React, { FunctionComponent } from "react";
import { TOPICS, TopicKey } from "../../topics";

export interface EmptySection {
  topic: TopicKey;
}

export const EMPTY_TOPIC_NOTE = "First story coming soon.";

export const EmptySection: FunctionComponent<EmptySection> = ({ topic }) => (
  <div className={`flex flex-col gap-2 p-5 ${TOPICS[topic].tintClass}`}>
    <div className="font-display text-lg font-extrabold">Nothing here yet</div>
    <p className="text-[15px] leading-[1.6] text-ink-soft">
      {TOPICS[topic].description} {EMPTY_TOPIC_NOTE}
    </p>
  </div>
);
